<section>
  <div class="container-style">
    <form novalidate [formGroup]="formDiscount" class="mb-2 py-1 px-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
          <p>Seleccione las opciones para aplicar el descuento al despiece.</p>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12 mb-1">
          <app-custom-select formControlName="familyId" [labelText]="'Familia'" [list]="listFamily"></app-custom-select>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12 mb-1">
          <app-custom-select formControlName="groupId" [labelText]="'Grupo'" [list]="listGroup"></app-custom-select>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12 mb-1">
          <app-custom-select formControlName="subgroupId" [labelText]="'Subgrupo'" [list]="listSubgroup"
            (onChangeSelect)="getSubgroup($event)"></app-custom-select>
        </div>
        <hr class="my-2">
        <div class="col-lg-4 col-md-6 col-sm-6 col-6">
          <app-custom-input-decimal formControlName="discount" [labelText]="'% Descuento'"
            [required]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-6 d-flex justify-content-end mt-3">
          <app-custom-button [label]="'Actualizar'" [severity]="'primary'" [variant]="undefined" [width]="'5rem'"
            (onClick)="applyDiscount()"></app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>